import { createFileRoute } from '@tanstack/react-router';
import { AdminDashboardPage } from '@/features/admin/admin-dashboard-page';
import { adminGuard } from '@/lib/route-guards';

export const Route = createFileRoute('/admin/')({
  beforeLoad: adminGuard,
  component: AdminIndexRoute,
});

function AdminIndexRoute() {
  return <AdminDashboardPage />;
}
